export default __webpack_public_path__ + "static/media/logo.b465efaa.svg";